import { onBeforeRouteLeave } from 'vue-router'
import { useDialog } from '../dialog'

export type CancelNavigationOption = {
  canLeave: () => boolean
  message?: string
}
export function useCancelNavigation(options: CancelNavigationOption) {
  const dialog = useDialog()
  onBeforeRouteLeave(async (_to, _from) => {
    // console.log('onBeforeRouteLeave', _to.name, _from.name)
    const canLeave = options.canLeave()
    if (canLeave === true) return true

    const result = await dialog.showDialog({
      message: options.message || 'Voulez-vous quitter sans sauvegarder ?',
      type: 'YesNo',
      closable: true,
    })
    return result === 'Yes'
  })
}

